/**
 * Technical & PMS permission codes — must match backend
 * `TechnicalPermissionCodes` / `ProcurementPermissionCodes`.
 */
export const TECH_PERM = {
  READ_TECHNICAL: 'READ_TECHNICAL',
  EXPORT_TECHNICAL: 'EXPORT_TECHNICAL',
  DOWNLOAD_TECHNICAL: 'DOWNLOAD_TECHNICAL',

  READ_MACHINERY: 'READ_MACHINERY',
  CREATE_MACHINERY: 'CREATE_MACHINERY',
  UPDATE_MACHINERY: 'UPDATE_MACHINERY',
  DELETE_MACHINERY: 'DELETE_MACHINERY',
  IMPORT_MACHINERY: 'IMPORT_MACHINERY',
  EXPORT_MACHINERY: 'EXPORT_MACHINERY',

  READ_SUBCOMPONENT: 'READ_SUBCOMPONENT',
  CREATE_SUBCOMPONENT: 'CREATE_SUBCOMPONENT',
  UPDATE_SUBCOMPONENT: 'UPDATE_SUBCOMPONENT',
  DELETE_SUBCOMPONENT: 'DELETE_SUBCOMPONENT',
  IMPORT_SUBCOMPONENT: 'IMPORT_SUBCOMPONENT',
  EXPORT_SUBCOMPONENT: 'EXPORT_SUBCOMPONENT',

  READ_PART: 'READ_PART',
  CREATE_PART: 'CREATE_PART',
  UPDATE_PART: 'UPDATE_PART',
  DELETE_PART: 'DELETE_PART',
  IMPORT_PART: 'IMPORT_PART',
  EXPORT_PART: 'EXPORT_PART',

  EXPORT_PMS: 'EXPORT_PMS',
  DOWNLOAD_PMS: 'DOWNLOAD_PMS',

  READ_PMS_DASHBOARD: 'READ_PMS_DASHBOARD',
  READ_PMS_JOB: 'READ_PMS_JOB',
  CREATE_PMS_JOB: 'CREATE_PMS_JOB',
  UPDATE_PMS_JOB: 'UPDATE_PMS_JOB',
  DELETE_PMS_JOB: 'DELETE_PMS_JOB',
  COMPLETE_PMS_JOB: 'COMPLETE_PMS_JOB',
  MASK_PMS_JOB: 'MASK_PMS_JOB',

  READ_RUNNING_HOURS: 'READ_RUNNING_HOURS',
  CREATE_RUNNING_HOURS: 'CREATE_RUNNING_HOURS',
  UPDATE_RUNNING_HOURS: 'UPDATE_RUNNING_HOURS',
  DELETE_RUNNING_HOURS: 'DELETE_RUNNING_HOURS',

  READ_PMS_CALENDAR: 'READ_PMS_CALENDAR',
  CREATE_PMS_CALENDAR: 'CREATE_PMS_CALENDAR',
  UPDATE_PMS_CALENDAR: 'UPDATE_PMS_CALENDAR',
  DELETE_PMS_CALENDAR: 'DELETE_PMS_CALENDAR',

  READ_TECHNICAL_FORM: 'READ_TECHNICAL_FORM',
  CREATE_TECHNICAL_FORM: 'CREATE_TECHNICAL_FORM',
  UPDATE_TECHNICAL_FORM: 'UPDATE_TECHNICAL_FORM',
  DELETE_TECHNICAL_FORM: 'DELETE_TECHNICAL_FORM',
  APPROVE_TECHNICAL_FORM: 'APPROVE_TECHNICAL_FORM',
  DOWNLOAD_TECHNICAL_FORM: 'DOWNLOAD_TECHNICAL_FORM',

  READ_TECHNICAL_LOCATION_LIBRARY: 'READ_TECHNICAL_LOCATION_LIBRARY',
  CREATE_TECHNICAL_LOCATION_LIBRARY: 'CREATE_TECHNICAL_LOCATION_LIBRARY',
  UPDATE_TECHNICAL_LOCATION_LIBRARY: 'UPDATE_TECHNICAL_LOCATION_LIBRARY',
  DELETE_TECHNICAL_LOCATION_LIBRARY: 'DELETE_TECHNICAL_LOCATION_LIBRARY',

  READ_TECHNICAL_GENERAL_ITEM_LIBRARY: 'READ_TECHNICAL_GENERAL_ITEM_LIBRARY',
  CREATE_TECHNICAL_GENERAL_ITEM_LIBRARY: 'CREATE_TECHNICAL_GENERAL_ITEM_LIBRARY',
  UPDATE_TECHNICAL_GENERAL_ITEM_LIBRARY: 'UPDATE_TECHNICAL_GENERAL_ITEM_LIBRARY',
  DELETE_TECHNICAL_GENERAL_ITEM_LIBRARY: 'DELETE_TECHNICAL_GENERAL_ITEM_LIBRARY',
  IMPORT_TECHNICAL_GENERAL_ITEM_LIBRARY: 'IMPORT_TECHNICAL_GENERAL_ITEM_LIBRARY',
  EXPORT_TECHNICAL_GENERAL_ITEM_LIBRARY: 'EXPORT_TECHNICAL_GENERAL_ITEM_LIBRARY',

  READ_TECHNICAL_LIBRARY: 'READ_TECHNICAL_LIBRARY',
  CREATE_TECHNICAL_LIBRARY: 'CREATE_TECHNICAL_LIBRARY',
  UPDATE_TECHNICAL_LIBRARY: 'UPDATE_TECHNICAL_LIBRARY',
  DELETE_TECHNICAL_LIBRARY: 'DELETE_TECHNICAL_LIBRARY',
} as const

export type TechnicalPermCode = (typeof TECH_PERM)[keyof typeof TECH_PERM]
